export default "skymp5-front/1354b2781cc3518cf267e90f5ec5ea9e.png";